import { h } from 'preact';
import PropTypes from 'prop-types';

// Utils
import { actionHandler } from '../../utilities/form/formUtils';

// Components
import Text from '../Global/Text';

const Label = ({
  id,
  label,
  className,
  actions,
  dispatch,
  setValues,
  values,
  toolTip,
}) => (
  <label
    className={className || 'form__label'}
    htmlFor={id}
  >
    {actions &&
    <button
      type="button"
      className="label__action button button--text"
      onClick={e => actionHandler(actions, null, e, dispatch, values, setValues)}
    >
      <Text value={label} toolTip={toolTip}/>
    </button>
    }
    {!actions &&
    <Text value={label} toolTip={toolTip}/>
    }
  </label>
);

export default Label;

Label.defaultProps = {
  className: null,
  actions: null,
  dispatch: null,
  toolTip: null,
};

Label.propTypes = {
  id: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  dispatch: PropTypes.func,
  actions: PropTypes.object,
  className: PropTypes.string,
  toolTip: PropTypes.string,
  setValues: PropTypes.func.isRequired,
  values: PropTypes.object.isRequired,
};


// WEBPACK FOOTER //
// ./src/components/Form/Label.jsx